import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface ICardSectionPaperProps {
  id?: string;
  children: React.ReactNode;
  redesign?: boolean;
}

export function CardSection({ children, id, redesign }: ICardSectionPaperProps) {
  return (
    <div className={cn(styles['section'], !redesign && styles['border'])} id={id}>
      {children}
    </div>
  );
}
